import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { Palette, FileText, Star, QrCode, TrendingUp as LeadsIcon, Users } from "lucide-react";
import * as tests from "./testDefinitions";

export const CustomersSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">👥 Customers</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Palette}
          iconColor="text-pink-600"
          title="Branding"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.brandingTests}
          results={testResults.branding}
        />
        
        <TestSubsection
          icon={FileText}
          iconColor="text-red-600"
          title="Waivers"
          badge={<Badge className="bg-red-500 text-white text-xs">Critical</Badge>}
          tests={tests.waiversTests}
          results={testResults.waivers}
        />
        
        <TestSubsection
          icon={Star}
          iconColor="text-yellow-600"
          title="Reviews"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.reviewsTests}
          results={testResults.reviews}
        />
        
        <TestSubsection
          icon={QrCode}
          iconColor="text-purple-600"
          title="Check-In"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.checkinTests}
          results={testResults.checkin}
        />
        
        <TestSubsection
          icon={LeadsIcon}
          iconColor="text-blue-600"
          title="Leads"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.leadsTests}
          results={testResults.leads}
        />
        
        <TestSubsection
          icon={Users}
          iconColor="text-green-600"
          title="Relations"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.relationsTests}
          results={testResults.relations}
        />
      </CardContent>
    </Card>
  );
};
